import { Component, Input, ViewChild } from "@angular/core";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { NgForm } from "@angular/forms";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";


@Component({
    selector: 'header-info-3461',
    templateUrl: "header-info-3461.component.html",
    moduleId: module.id.toString()
})
export class HeaderInfo3461Component {
    @Input()
    public document: CBP3461;

    public numberPatternHelper = ValidationPatterns;

    @ViewChild("headerInfoForm")
    public headerInfoForm: NgForm;

    public stringHelper = String;

    public submitFormAndValidity(): boolean {
        this.headerInfoForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean {
        return this.headerInfoForm.valid;
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-blocks/header-info-3461.component.ts